import { useState, useEffect, useMemo, useCallback } from "react";
import { AgGridReact } from "ag-grid-react";
import api from "api/api";
import { useNavigate, useLocation } from "react-router-dom";

//Props Validations
import PropTypes from "prop-types";

//Material UI Components
// import Typography from "@mui/material/Typography";

import Tooltip from "@mui/material/Tooltip";
// import Switch from "@mui/material/Switch";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

// import mui icons
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
// import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
// import ShareRoundedIcon from "@mui/icons-material/ShareRounded";

// import component
import Header from "../components/common/Header";
import GetIconHeader from "utils/GetIconHeader";
import FiltersHeaderLabel from "../components/common/FiltersHeaderLabel";

// assets

import products from "../assets/icons/productCategory.png";
import studyPeriods from "../assets/icons/study_period.png";
import identifier from "../assets/icons/identifier.png";
import downloadIcon from "../assets/icons/download.png";
import studyReference from "../assets/icons/studyReference.png";
import action from "../assets/icons/studyReference.png";
import analyse from "../assets/icons/unileverProduct.png";
import country from "../assets/icons/country.png";
import studyType from "../assets/icons/studyType.png";
import competitorProduct from "../assets/icons/competitorProduct.png";
import targetKpis from "../assets/icons/targetKpi.png";
import savedIcon from "../assets/icons/savedIcon.png";
import unsavedIcon from "../assets/icons/unsavedIcon.png";
import share from "../assets/icons/share.png";
import deleteIcon from "../assets/icons/deleteIcon.png";
import algorithmIcon from "../assets/icons/algorithmIcon.png"; // Import algorithm icon

import { useSelector, useDispatch } from "react-redux";
import ShareDialog from "../components/driverAnalysis/ShareDialog";
import Pagination from "../components/common/Pagination";

import { showNotification } from "store/features/notificationSlice";

function DriverAnalysis({ headerTitle = "Driver Analysis" }) {
    const dispatch = useDispatch();

    const navigate = useNavigate();
    const location = useLocation();
    const isFragranceDriver = location.state?.isFragranceDriver === true;
    const userId = useSelector((state) => state.userStore.id);
    
    const role = useSelector((state) => state.userStore.role) || null;
    const productsTestCodeMapData = useSelector((state) => state.studyDataStore.productTestCodeMap);

    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);
    const productCategoryId = productCategoryData?.value || null;

    const [rowData, setRowData] = useState([]);
    const [columnDefs, setColumnDef] = useState([]);
    // const [isSavedView, setIsSavedView] = useState(true);

    const [tab, setTab] = useState(null);

    // share report
    const [openShareDialog, setOpenShareDialog] = useState(false);
    const [selectedReportForShare, setSelectedReportForShare] = useState({});

    // pagination
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [nextUrl, setNextUrl] = useState(null);
    const [previousUrl, setPreviousUrl] = useState(null);

    const isOralCare = process.env?.REACT_APP_ORAL_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCare = process.env?.REACT_APP_SKIN_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isUnileverFragranceHouse = process.env?.REACT_APP_UNILEVER_FRAGRANCE_HOUSE?.toLowerCase() === productCategoryData?.label?.toLowerCase();

    const isBeatyAndWellBeing = isHairCare || isSkinCare;

    const handlePageSizeChange = (event, newPageSize) => {
        setPageSize(newPageSize);
    };

    const handleNextPageClick = () => {
        // fetchDriverAnalysisTableResult(nextUrl)
        setPage(page + 1);
    };
    const handlePreviousPageClick = () => {
        // fetchDriverAnalysisTableResult(previousUrl)
        setPage(page - 1);
    };

    const handleChange = (event, newValue) => {
        if (newValue) {
            setTab(newValue);
            setPage(0);
            setPageSize(10);
            setTotalCount(0);
            setNextUrl(null);
            setPreviousUrl(null);
        }
    };

    useEffect(() => {
        if ((role && role.toLowerCase() === "admin") || (isBeatyAndWellBeing || isUnileverFragranceHouse)) {
            setTab("saved");
        } else {
            setTab("shared");
        }
    }, [role, isBeatyAndWellBeing, isUnileverFragranceHouse]);

    const handleClickOpenShareDialog = (data = {}) => {
        setSelectedReportForShare(data);
        setOpenShareDialog(true);
    };

    const handleCloseShareDialog = () => {
        setOpenShareDialog(false);
        setSelectedReportForShare({});
    };

    const fetchDriverAnalysisTableResult = useCallback(async () => {
        if (tab) {
            try {
                let baseUrl;
                baseUrl = tab === "shared" ? `${process.env.REACT_APP_SERVER_PATH}/driver-analysis-output/shared/?archive=false&shared_with=${userId}` : `${process.env.REACT_APP_SERVER_PATH}/driver-analysis-output/all/?archive=false&saved=${tab === "unsaved" ? false : true}`;
                // baseUrl = `${process.env.REACT_APP_SERVER_PATH}/driver-analysis-output/shared/?shared_with=${userId}`;

                if (productCategoryId) {
                    baseUrl += `&product_category=${productCategoryId}`;
                }
                if (pageSize) {
                    baseUrl += `&limit=${pageSize}`;
                }
                if (page) {
                    baseUrl += `&offset=${page * pageSize}`;
                }
                await api
                    .get(baseUrl)
                    .then((res) => {
                        const results = res?.data?.results || [];
                        const filteredResults = isFragranceDriver ? results.filter((report) => report.report_type === "fragrance") : results.filter((report) => report.report_type !== "fragrance");                        
                        setRowData(filteredResults);
                        setTotalCount(filteredResults.length || 0);
                        setNextUrl(res?.data.next || null);
                        setPreviousUrl(res?.data.previous || null);
                    })
                    .catch((error) => {
                        handleError("error", error);
                    });
            } catch (error) {
                handleError("error", error);
            }
        }
    }, [tab, productCategoryId, userId, pageSize, page, isFragranceDriver]);

    useEffect(() => {
        fetchDriverAnalysisTableResult();
    }, [fetchDriverAnalysisTableResult]);

    const handleUpdateDriverAnalysis = async (params) => {
        let savedView = true;
        if (tab && tab === "unsaved") {
            savedView = false;
        }

        try {
            const url = `${process.env.REACT_APP_SERVER_PATH}/driver-analysis-output/${params.data.id}/`;
            const payload = {
                saved: !savedView,
            };
            await api
                .put(url, payload)
                .then(() => {
                    handleError("success", `Report ${!savedView ? "saved" : "unsaved."}`);
                })
                .catch((error) => {
                    handleError("error", error);
                });
            await fetchDriverAnalysisTableResult();
        } catch (error) {
            handleError("error", error);
        }
    };

    const handleDeleteDriverAnalysis = async (params) => {
        try {
            const url = `${process.env.REACT_APP_SERVER_PATH}/driver-analysis-output/${params.id}/`;
            const payload = {
                archive: true,
            };
            await api
                .patch(url, payload)
                .then(() => {
                    handleError("success", "Report deleted");
                    fetchDriverAnalysisTableResult();
                })
                .catch((error) => {
                    handleError("error", error);
                });
        } catch (error) {
            handleError("error", error);
        }
    };

    const handleRevokeDriverAnalysisAccess = async (data = {}) => {
        if (data?.accessId) {
            const url = process.env.REACT_APP_SERVER_PATH + `/driver-analysis-output-shares/${data.accessId}/`;
            await api
                .delete(url)
                .then(async () => {
                    fetchDriverAnalysisTableResult();
                    handleError("success", "Access Revoked");
                })
                .catch(async (error) => {
                    handleError("error", error);
                });
        }
    };

    const handleAnalyzeClick = (params) => {
        navigate(`/driver-analysis/report/id=${params.data.id}`, {
            state: { view: tab },
        });
    };

    const handleDownloadDriverAnalysis = (params) => {
        if (window.location.href.split("/").indexOf("driver-analysis")) {
            const id = params.data.id;
            let url = process.env.REACT_APP_SERVER_PATH + `/driver-analysis-output/export/?id=${id}&user=${userId}`;
            if (tab === "shared") {
                url += `&shared=true`;
            }
            window.open(url);
        }
    };

    const multipleCellRenderer = (params) => {
        if (Array.isArray(params.value) && params.value.length > 0) {
            return (
                <div className="ag-multi-line-cell-render">
                    {params.value.map((val, i) => {
                        return <p key={i}>{val}</p>;
                    })}
                </div>
            );
        } else {
            return params.value;
        }
    };

    const productsCellRenderer = (params) => {
        const values = Array.isArray(params.value) ? params.value : [params.value];

        return (
            <div className="ag-multi-line-cell-render">
                {values.map((val, idx) => {
                    const proTitle = `${val}__${params.data.core_data_ids}`;
                    const proTestCode = productsTestCodeMapData[proTitle];
                    const [mainVal] = val.split("/");

                    return (
                        <p
                            key={`${proTitle}_${idx}`}
                            style={{ display: "flex" }}
                        >
                            <span>{val.includes(proTestCode) ? mainVal : val}</span>
                            {isOralCare && (
                                <>
                                    <span style={{ marginTop: "5px" }}>&nbsp;/&nbsp;</span>
                                    <span style={{ color: "#6f42c1", marginTop: "5px" }}>{proTestCode}</span>
                                </>
                            )}
                        </p>
                    );
                })}
            </div>
        );
    };

    // Algorithm cell renderer function
    const algorithmCellRenderer = (params) => {
        const algorithmValue = params.value;

        if (!algorithmValue) {
            return "";
        }

        // Map algorithm values to display names
        const algorithmDisplayNames = {
            relative_weight_analysis: "Relative Weight Analysis",
            partial_least_squares: "Partial Least Squares",
            random_forest_classifier: "Random Forest Classifiers",
        };

        const displayName = algorithmDisplayNames[algorithmValue] || algorithmValue;

        return <div style={{ textAlign: "left" }}>{displayName}</div>;
    };

    const defaultCol = [
        {
            headerName: "Identifier",
            field: "identifier",
            headerComponentParams: {
                template: GetIconHeader("Identifier", identifier),
            },
        },
        {
            headerName: "Algorithm",
            field: "algorithm",
            maxWidth: 200,
            cellRenderer: algorithmCellRenderer,
            headerComponentParams: {
                template: GetIconHeader("Algorithm", algorithmIcon),
            },
        },
        {
            headerName: "Analyse",
            field: "analyse",
            maxWidth: 100,
            headerComponentParams: {
                template: GetIconHeader((role && role.toLowerCase() === "admin") ? "Analyse" : "View", analyse),
            },
            cellRenderer: (params) => (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <Tooltip
                        title={params?.data?.overall_accuracy ? ((role && role.toLowerCase() === "admin") ? "Analyse" : "View") : "The report generation is underway"}
                        placement="top"
                    >
                        <RemoveRedEyeIcon
                            color={params?.data?.overall_accuracy ? "primary" : ""}
                            style={{
                                cursor: params?.data?.overall_accuracy ? "pointer" : "",
                            }}
                            onClick={() => {
                                if (params?.data?.overall_accuracy) {
                                    handleAnalyzeClick(params);
                                }
                            }}
                        />
                    </Tooltip>
                </div>
            ),
        },
        // Country only for HairCare & SkinCare
    ...(isBeatyAndWellBeing
        ? [
              {
                  headerName: "Country",
                  field: "country",
                  headerComponentParams: {
                      template: GetIconHeader("Country", country),
                  },
                  cellStyle: { textAlign: "center" },
              },
          ]
        : []),
        {
            headerName: "Study Type",
            field: "study_type",
            headerComponentParams: {
                template: GetIconHeader("Study Type", competitorProduct),
            },
        },
        {
            headerName: "Study Type Method",
            field: "study_type_method",
            headerComponentParams: {
                template: GetIconHeader("Study Type Method", studyType),
            },
        },
        {
            headerName: "Study Period",
            field: "study_period",
            cellRenderer: multipleCellRenderer,
            autoHeight: true,
            wrapText: true,
            headerComponentParams: {
                template: GetIconHeader("Study Period", studyPeriods),
            },
            cellStyle: { textAlign: "center" },
        },
        {
            headerName: "Study Reference",
            field: "study_reference",
            minWidth: 350,
            autoHeight: true,
            wrapText: true,
            cellRenderer: multipleCellRenderer,
            headerComponentParams: {
                template: GetIconHeader("Study Reference", studyReference),
            },
        },
        {
            headerName: "Target KPI",
            field: "target_kpi_label",
            minWidth: 300,
            headerComponentParams: {
                template: GetIconHeader("Target KPI", targetKpis),
            },
        },
        {
            headerName: "Products",
            field: "product_codes",
            minWidth: 450,
            autoHeight: true,
            wrapText: true,
            cellRenderer: productsCellRenderer,
            headerComponentParams: {
                template: GetIconHeader("Products", products),
            },
        },
        {
            headerName: "Action",
            field: "action",
            maxWidth: 150,
            cellRenderer: (params) => (
                <div
                    style={{
                        display: "flex",
                        gap: "10px",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    {/* Show action buttons for admin OR for hair care/skin care normal users */}
                    {((role && role.toLowerCase() === "admin") || (isBeatyAndWellBeing || isUnileverFragranceHouse)) && (
                        <>
                            {tab && tab !== "shared" && (
                                <Tooltip
                                    title={tab && tab === "saved" ? "Unsave" : "Save"}
                                    placement="top"
                                >
                                    <img
                                        src={tab && tab === "saved" ? unsavedIcon : savedIcon}
                                        alt="Saved Status Icon"
                                        style={{
                                            width: "22px",
                                            height: "22px",
                                            cursor: params?.data?.overall_accuracy ? "pointer" : "",
                                            filter: params?.data?.overall_accuracy ? "" : "grayscale(100%)",
                                        }}
                                        onClick={() => {
                                            if (params?.data?.overall_accuracy) {
                                                handleUpdateDriverAnalysis(params);
                                            }
                                        }}
                                    />
                                </Tooltip>
                            )}

                            <Tooltip
                                title={"Share"}
                                placement="top"
                            >
                                <img
                                    src={share}
                                    alt="Share"
                                    style={{
                                        width: "22px",
                                        height: "22px",
                                        cursor: params?.data?.overall_accuracy ? "pointer" : "",
                                        filter: params?.data?.overall_accuracy ? "" : "grayscale(100%)",
                                    }}
                                    onClick={() => {
                                        if (params?.data?.overall_accuracy) {
                                            handleClickOpenShareDialog(params.data);
                                        }
                                    }}
                                />
                            </Tooltip>
                        </>
                    )}

                    <Tooltip
                        title="Delete"
                        placement="top"
                    >
                        <img
                            src={deleteIcon}
                            alt="Delete"
                            style={{
                                width: "22px",
                                height: "22px",
                                cursor: "pointer",
                            }}
                            onClick={() => {
                                if (tab && tab !== "shared" && role && role.toLowerCase() === "admin") {
                                    handleDeleteDriverAnalysis(params.data);
                                } else if (tab && tab === "shared") {
                                    handleRevokeDriverAnalysisAccess(params.data);
                                } else if ((isBeatyAndWellBeing || isUnileverFragranceHouse) && tab && tab !== "shared") {
                                    // For hair care/skin care normal users, allow delete from saved/unsaved tabs
                                    handleDeleteDriverAnalysis(params.data);
                                }
                            }}
                        />
                        {/* <DeleteOutlinedIcon
                            style={{
                                cursor: "pointer",
                                color: "red",
                            }}
                            onClick={() => handleDeleteDriverAnalysis(params)}
                        /> */}
                    </Tooltip>
                </div>
            ),
            headerComponentParams: {
                template: GetIconHeader("Action", action),
            },
        },
        {
            headerName: "Download",
            field: "download",
            maxWidth: 110,

            cellRenderer: (params) => (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <Tooltip
                        title={params?.data?.overall_accuracy ? "Download" : "The report generation is underway"}
                        placement="top"
                    >
                        <img
                            src={downloadIcon}
                            alt="Download Icon"
                            style={{
                                width: "23px",
                                height: "17px",
                                cursor: params?.data?.overall_accuracy ? "pointer" : "",
                                filter: params?.data?.overall_accuracy ? "" : "grayscale(100%)",
                            }}
                            onClick={() => {
                                if (params?.data?.overall_accuracy) {
                                    handleDownloadDriverAnalysis(params);
                                }
                            }}
                        />
                    </Tooltip>
                </div>
            ),
            headerComponentParams: {
                template: GetIconHeader("Download", downloadIcon),
            },
        },
    ];

    const sharedColumn = [
        {
            headerName: "Shared by",
            field: "shared_by__email",
            minWidth: 250,
            headerComponentParams: {
                template: GetIconHeader("Shared by", identifier),
            },
        },
        {
            headerName: "Created by",
            field: "created_by__email",
            minWidth: 250,
            headerComponentParams: {
                template: GetIconHeader("Created by", identifier),
            },
        },
    ];

    const defaultColDef = useMemo(() => {
        return {
            editable: false,
            suppressMenu: true,
            sortable: true,
            filter: true,
            resizable: true,
            // floatingFilter: true,
            filterParams: {
                filterOptions: ["contains"], // to get filter remove class .ag-floating-filter-button  form css
                // filterOptions: ["equals", "contains", "startsWith", "endsWith"], // to get filter remove class .ag-floating-filter-button  form css
            },
            cellStyle: {
                fontSize: "14px",
                border: "none",
                padding: 10,
            },
            minWidth: 200,
        };
    }, []);

    const handleError = (type, error) => {
        dispatch(showNotification({ severity: type, data: error }));
    };

    useEffect(() => {
        let baseCols = (isBeatyAndWellBeing || isUnileverFragranceHouse) ? [...defaultCol] : defaultCol.filter((col) => col.field !== "algorithm");
        const col = tab && tab === "shared" ? [...baseCols, ...sharedColumn] : [...baseCols];
        setColumnDef(col);
        setRowData([]);

        // reset pagination on tab change
    }, [tab]);

    return (
        <>
            <Header title={headerTitle} />
            <div
                className="ms-4 me-4 mb-0 mt-3 background-color-white box-shadow--2 d-flex"
                style={{
                    borderRadius: "5px",
                }}
            >
                <FiltersHeaderLabel />
            </div>
            <div
                style={{
                    minHeight: "calc(100vh - 110px)",
                    padding: "20px",
                    margin: "20px",
                    marginTop: "35px",
                }}
                className="full-container m-4 background-color-white  box-shadow--full-container"
            >
                <div
                    className=""
                    style={{
                        width: 150,
                        display: "flex",
                        alignItems: "center",
                        position: "absolute",
                    }}
                >
                    <div
                        className="p-2 liner-light-blue-background color-white"
                        style={{
                            borderRadius: "50%",
                            position: "relative",
                            top: -35,
                            left: -35,
                            cursor: "pointer",
                            zIndex: 10,
                        }}
                        onClick={() => navigate(-1)}
                    >
                        <span>
                            <ArrowBackIcon className="color-white" />
                        </span>
                    </div>
                </div>

                <div>
                    <div
                        className="card-btns"
                        style={{
                            padding: "0px 0px",
                            margin: "10px 0px",
                            marginBottom: "8px",
                            paddingBottom: "8px",
                        }}
                    ></div>

                    {/* Show toggle buttons for admin OR for hair care/skin care normal users */}
                    {((role && role.toLowerCase() === "admin") || (isBeatyAndWellBeing || isUnileverFragranceHouse)) && (
                        <ToggleButtonGroup
                            color="primary"
                            value={tab}
                            exclusive
                            onChange={handleChange}
                            aria-label="Platform"
                            size="small"
                        >
                            <ToggleButton value="saved">
                                <Tooltip
                                    title="Saved"
                                    placement="top"
                                >
                                    <img
                                        src={savedIcon}
                                        alt="Saved Status Icon"
                                        style={{
                                            width: "22px",
                                            height: "22px",
                                            cursor: "pointer",
                                            filter: tab && tab !== "saved" ? "grayscale(100%)" : "",
                                        }}
                                    />
                                </Tooltip>
                            </ToggleButton>
                            <ToggleButton value="unsaved">
                                <Tooltip
                                    title="Unsaved"
                                    placement="top"
                                >
                                    <img
                                        src={unsavedIcon}
                                        alt="Unsaved Status Icon"
                                        style={{
                                            width: "22px",
                                            height: "22px",
                                            cursor: "pointer",
                                            filter: tab && tab !== "unsaved" ? "grayscale(100%)" : "",
                                        }}
                                    />
                                </Tooltip>
                            </ToggleButton>
                            <ToggleButton value="shared">
                                <Tooltip
                                    title="Share with me"
                                    placement="top"
                                >
                                    <img
                                        src={share}
                                        alt="Shared Status Icon"
                                        style={{
                                            width: "22px",
                                            height: "22px",
                                            cursor: "pointer",
                                            filter: tab && tab !== "shared" ? "grayscale(100%)" : "",
                                        }}
                                    />
                                </Tooltip>
                            </ToggleButton>
                        </ToggleButtonGroup>
                    )}

                    <div
                        className="ag-theme-alpine"
                        style={{
                            height: "calc(100vh - 290px)",
                            width: "100%",
                        }}
                    >
                        <style>
                            {`
                                .ag-header-group-cell-label {
                                    justify-content: center !important;
                                }
                                .ag-header-cell-comp-wrapper {
                                    justify-content: center !important;
                                }
                                `}
                        </style>
                        <AgGridReact
                            columnDefs={columnDefs}
                            rowData={rowData}
                            defaultColDef={defaultColDef}
                            rowHeight={30}
                            headerHeight={60}
                        ></AgGridReact>
                    </div>
                    <Pagination
                        page={page}
                        setPage={setPage}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                        handlePageSizeChange={handlePageSizeChange}
                        pageSizeOptions={[5, 10, 20, 50]}
                        totalCount={totalCount}
                        handleNextPageClick={handleNextPageClick}
                        handlePreviousPageClick={handlePreviousPageClick}
                        disableNextPage={!nextUrl}
                        disablePreviousPage={!previousUrl}
                    />
                    <div className="d-flex">
                        <span
                            style={{
                                fontSize: 12,
                                color: "#495057",
                                fontWeight: 600,
                                marginLeft: "auto",
                            }}
                        >
                            Total {rowData.length} rows
                        </span>
                    </div>
                    {/* </div> */}
                </div>
            </div>
            {/* Show ShareDialog for admin OR for hair care/skin care normal users */}
            {((role && role.toLowerCase() === "admin") || (isBeatyAndWellBeing || isUnileverFragranceHouse)) && (
                <ShareDialog
                    data={selectedReportForShare}
                    open={openShareDialog}
                    handleCloseShareDialog={handleCloseShareDialog}
                    fetchDriverAnalysisTableResult={fetchDriverAnalysisTableResult}
                />
            )}
        </>
    );
}

// Typechecking props for the DriverAnalysis
DriverAnalysis.propTypes = {
    headerTitle: PropTypes.string,
};

export default DriverAnalysis;
